// extracted by mini-css-extract-plugin
export default {"priceWrapper":"_f6ab0eca","pillWrapper":"_cd645c5e","paddle":"_b940d94c"};